import { render, staticRenderFns } from "./LocalNotificationList.vue?vue&type=template&id=d9e5093a&scoped=true&"
import script from "./LocalNotificationList.vue?vue&type=script&lang=ts&"
export * from "./LocalNotificationList.vue?vue&type=script&lang=ts&"
import style0 from "./LocalNotificationList.vue?vue&type=style&index=0&id=d9e5093a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9e5093a",
  null
  
)

export default component.exports